// import { setCookie } from '../../../utils/Cookie';
//
// export const setAllUtmToCookie = () => {
//   const url = window.location.search;
//   const searchParams = new URLSearchParams(url);
//
//   for (const [key, value] of searchParams.entries()) {
//     setCookie(`${key}`, `${value}`, 60 * 60 * 24 * 90);
//   }
// };

import { setCookie } from '../../../utils/Cookie';

const extendCookiesDictionary = {
  'utm_source': 'utm_source_fb-kad',
  'utm_medium': 'utm_medium_fb-kad',
  'utm_campaign': 'utm_campaign_fb-kad',
  'utm_content': 'utm_content_fb-kad',
  'transaction_id': 'transaction_id',
  'gcpc': 'passed_gcpc'
}

const extendDynamicParamsDictionary = {
  'transaction_id': 'transaction_id',
  'gcpc': 'passed_gcpc'
}

export const setAllUtmToCookie = () => {
  const url = window.location.search;
  const searchParams = new URLSearchParams(url);
  const existParams = [];

  for (const [key, value] of searchParams.entries()) {
    setCookie(`${key}`, `${value}`, 60 * 60 * 24 * 90);
    if (key in extendCookiesDictionary) {
      setCookie(extendCookiesDictionary[key], `${value}`, 60 * 60 * 24 * 90);
    }
    existParams.push(key);
  }

  for (const [key, value] of Object.entries(extendDynamicParamsDictionary)) {
    if (!existParams.includes(key)) {
      setCookie(extendCookiesDictionary[key], ``, -1);
    }
  }
};
